export default __webpack_public_path__ + "src/assets/trust-3.ace11a66c30b0a85e616515d7d7b6999.svg";